import * as React from "react";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/utils/common.utils";
import { STATUS_BADGE_TONES } from "@/constant/common.constant";

interface StatusBadgeProps extends React.ComponentPropsWithoutRef<typeof Badge> {
  tone?: string;
}

export default function StatusBadge({ tone = "neutral", children, className, ...props }: StatusBadgeProps) {
  return <Badge variant="outline" className={cn("rounded-full", STATUS_BADGE_TONES[tone] || tone, className)} {...props}>{children}</Badge>;
}
